import { render, staticRenderFns } from "./RepairTypeIco.vue?vue&type=template&id=469c70d6&scoped=true&"
import script from "./RepairTypeIco.vue?vue&type=script&lang=js&"
export * from "./RepairTypeIco.vue?vue&type=script&lang=js&"
import style0 from "./RepairTypeIco.vue?vue&type=style&index=0&id=469c70d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469c70d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
